import { makeStyles } from "@material-ui/core/styles";
// import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from "constants";

export const appBarConstants = {
	height: "50px",
	backgroundColor: "#FFEC0F",
};

export const navBarConstants = {
	drawerWidth: "280px",
	backgroundColor: "#000000",
};

//Todo: update base background color in theme, delete app style
const appStyles = makeStyles(() => ({
	app: {
		width: "100hw",
		height: "100vh",
	},
	root: {
		display: "flex",
		height: "100%",
	},
	content: {
		paddingTop: appBarConstants.height,
		width: "100%",
	},
	pageContainer: {
		maxWidth: "1520px",
		height: "100%",
		width: "100%",
		padding: "16px",
		margin: 0,
	},
	link: {
		textDecoration: 'underline',
	}
}));
export default appStyles;
